import React from 'react';
import './Logo.css';

const Logo = ({ showTagline = false, size = 'medium', useImage = true, imageSrc = '/logo.png' }) => {
  // Logo image should be placed in client/public/logo.png
  // The component will try to use the image, but gracefully falls back to CSS version if image doesn't load
  const [imageError, setImageError] = React.useState(false);
  
  if (useImage && !imageError) {
    return (
      <div className={`logo-container logo-${size}`}>
        <img 
          src={imageSrc} 
          alt="MunchUps Logo" 
          className="logo-image"
          onError={() => setImageError(true)}
        />
        {showTagline && (
          <div className="logo-tagline">
            <span>MUNCH, CRUNCH, LOVE THE PUNCH</span>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={`logo-container logo-${size}`}>
      {/* CSS-based logo matching the description */}
      <div className="logo-wrapper">
        <div className="logo-box">
          <div className="box-face">
            <div className="box-eyes">
              <div className="eye left"></div>
              <div className="eye right"></div>
            </div>
            <div className="box-mouth"></div>
          </div>
          <div className="snacks-overflow">
            <div className="snack snack-1"></div>
            <div className="snack snack-2"></div>
            <div className="snack snack-3"></div>
          </div>
        </div>
        
        <div className="logo-text">
          <span className="brand-name">MunchUps</span>
        </div>
        
        {showTagline && (
          <div className="logo-tagline">
            <span>MUNCH, CRUNCH, LOVE THE PUNCH</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Logo;
